import { useState, useEffect, useRef } from 'react';
import { get } from 'lodash';
import localStorage from 'components/atoms/tables/smarttables/helpers/localStorage';

function useCachedState(cacheId, defaultValue) {
    const isInitialMount = useRef(true);

    const [value, setValue] = useState(() => {
        const val = localStorage.get(cacheId);
        if (val) {
            // pull the origional value out from JSON.parse on first load.
            return get(JSON.parse(val), 'value', defaultValue);
        }
        return defaultValue;
    });

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            localStorage.set(cacheId, JSON.stringify({ value }));
        }
    }, [value, cacheId]);
    useEffect(() => {
        const val = localStorage.get(cacheId);
        if (val) {
            // pull the origional value out from JSON.parse on first load.
            setValue(JSON.parse(val).value);
        }
    }, [cacheId]);
    const set = (val) => {
        setValue(val);
    };
    return [value, set];
}
export default useCachedState;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/helpers/useCachedState.js